import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { EstateTaskUserTypeKey } from '@/modules/estatetask/enums/EstateTaskUserTypeKey';

export class EstateTaskUserType extends Enum {
  key!: EstateTaskUserTypeKey;
  value!: string;

  static RESEARCH: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.RESEARCH,
    get value(): string {
      return Lang.t('estatetask.research');
    }
  };

  static DATA_ENTRY: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.DATA_ENTRY,
    get value(): string {
      return Lang.t('estatetask.data_entry');
    }
  };

  static FIRST_NOTIFICATIONS: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.FIRST_NOTIFICATIONS,
    get value(): string {
      return Lang.t('estatetask.notification_and_delivery');
    }
  };

  static DRAFT_PROBATE_OR_PETITION_APPLICATION: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.DRAFT_PROBATE_OR_PETITION_APPLICATION,
    get value(): string {
      return Lang.t('estatetask.draft_probate_or_petition_application');
    }
  };

  static ASSET_CHECKLIST: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.ASSET_CHECKLIST,
    get value(): string {
      return Lang.t('estatetask.asset_checklist');
    }
  };

  static DRAFT_INVENTORY_FORMS: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.DRAFT_INVENTORY_FORMS,
    get value(): string {
      return Lang.t('estatetask.draft_inventory_forms');
    }
  };

  static DRAFTING_DISTRIBUTION_FORMS: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.DRAFTING_DISTRIBUTION_FORMS,
    get value(): string {
      return Lang.t('estatetask.drafting_distribution_forms');
    }
  };

  static FILE_CLOSING: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.FILE_CLOSING,
    get value(): string {
      return Lang.t('estatetask.file_closing');
    }
  };

  static CLIENT_COMMUNICATION: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.CLIENT_COMMUNICATION,
    get value(): string {
      return Lang.t('user.client-communication');
    }
  };

  static REVIEW_MEETING: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.REVIEW_MEETING,
    get value(): string {
      return Lang.t('estatetask.review_meeting');
    }
  };

  static DOCUMENT_PREPARATION: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.DOCUMENT_PREPARATION,
    get value(): string {
      return Lang.t('estatetask.create_documents_forms');
    }
  };

  static NOTARY_BOOKING: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.NOTARY_BOOKING,
    get value(): string {
      return Lang.t('estatetask.notary_booking');
    }
  };

  static UPDATE_OC_FAQ: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.UPDATE_OC_FAQ,
    get value(): string {
      return Lang.t('estate.update_oc_faq');
    }
  };

  static CHARGEBACKS: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.CHARGEBACKS,
    get value(): string {
      return Lang.t('estate.chargebacks');
    }
  };

  static PETITION_FOR_CLOSING: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.PETITION_FOR_CLOSING,
    get value(): string {
      return Lang.t('estate.petition_for_closing');
    }
  };

  static FILE_INTAKE: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.FILE_INTAKE,
    get value(): string {
      return Lang.t('estatetask.file_intake');
    }
  };

  static CLIENT_MEETING: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.CLIENT_MEETING,
    get value(): string {
      return Lang.t('estatetask.client_meeting');
    }
  };

  static INTERNAL_COMMUNICATION: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.INTERNAL_COMMUNICATION,
    get value(): string {
      return Lang.t('estatetask.internal_communication');
    }
  };

  static REVIEW_FILE_INFO: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.REVIEW_FILE_INFO,
    get value(): string {
      return Lang.t('estatetask.review_file_info');
    }
  };

  static CONTACT_THIRD_PARTY: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.CONTACT_THIRD_PARTY,
    get value(): string {
      return Lang.t('estatetask.contact_third_party');
    }
  };

  static MAIL_COURIER_EFILE_FAX: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.MAIL_COURIER_EFILE_FAX,
    get value(): string {
      return Lang.t('estatetask.mail_courier_efile_fax');
    }
  };

  static COURT_PROCESSES: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.COURT_PROCESSES,
    get value(): string {
      return Lang.t('estatetask.court_processes');
    }
  };

  static OFFICE_ADMINISTRATION: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.OFFICE_ADMINISTRATION,
    get value(): string {
      return Lang.t('estatetask.office_administration');
    }
  };

  static BUG_VERIFICATION: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.BUG_VERIFICATION,
    get value(): string {
      return Lang.t('estatetask.bug_verification');
    }
  };

  static OTHER: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.OTHER,
    get value(): string {
      return Lang.t('estatetask.other');
    }
  };

  static REVIEW_DOCUMENTS: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.REVIEW_DOCUMENTS,
    get value(): string {
      return Lang.t('estatetask.review_documents');
    }
  };

  static GENERATE_FROM_PLATFORM: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.GENERATE_FROM_PLATFORM,
    get value(): string {
      return Lang.t('estatetask.generate_from_platform');
    }
  };

  static TAX_DOCUMENTS: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.TAX_DOCUMENTS,
    get value(): string {
      return Lang.t('estatetask.tax_documents');
    }
  };

  static CLEARANCE_CERTIFICATE_PREP: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.CLEARANCE_CERTIFICATE_PREP,
    get value(): string {
      return Lang.t('estatetask.clearance_certificate_prep');
    }
  };

  static OC_COMMUNICATION: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.OC_COMMUNICATION,
    get value(): string {
      return Lang.t('estatetask.oc_communication');
    }
  };

  static CREATE_EDITING_DOCUMENTS_FORMS: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.CREATE_EDITING_DOCUMENTS_FORMS,
    get value(): string {
      return Lang.t('estatetask.create_editing_documents_forms');
    }
  };

  static GENERATE_WILL_AND_POA: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.GENERATE_WILL_AND_POA,
    get value(): string {
      return Lang.t('estatetask.generate_will_and_poa');
    }
  };

  static REVISE_DOCUMENTS: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.REVISE_DOCUMENTS,
    get value(): string {
      return Lang.t('estatetask.revise_documents');
    }
  };

  static PRE_CUSTOMER_MEETING_WORK: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.PRE_CUSTOMER_MEETING_WORK,
    get value(): string {
      return Lang.t('estatetask.pre_customer_meeting_work');
    }
  };

  static AOE_COMMUNICATION: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.AOE_COMMUNICATION,
    get value(): string {
      return Lang.t('estatetask.aoe_communication');
    }
  };

  static GUIDANCE_MEETING: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.GUIDANCE_MEETING,
    get value(): string {
      return Lang.t('estatetask.guidance_meeting');
    }
  };

  static INTAKE_MEETING_NEW: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.INTAKE_MEETING_NEW,
    get value(): string {
      return Lang.t('estatetask.intake_meeting_new');
    }
  };

  static AUDIT_REVIEW: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.AUDIT_REVIEW,
    get value(): string {
      return Lang.t('estatetask.audit_review');
    }
  };

  static AUDIT_REQUIRED_ACTION: EstateTaskUserType = {
    key: EstateTaskUserTypeKey.AUDIT_REQUIRED_ACTION,
    get value(): string {
      return Lang.t('estatetask.audit_required_action');
    }
  };
}
